<template>
  <div class="center-container d-flex flex-column inherit-height full-width justify-center align-center ">
    <v-avatar size="16em" color="grey lighten-3">
      <v-icon size="10em">{{ icon }}</v-icon>
    </v-avatar>
    <h5 class="text-h5 mt-5 grey--text text--darken-2">{{ text }}</h5>
    <h6 v-if="subtitle" class="text-subtitle-1 mt-2 grey--text text--darken-2">{{ subtitle }}</h6>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.center-container {
  text-align: center;
  /* top: 15%;
  left: 0;
  right: 0;
  margin: auto; */
}
</style>
